module.exports = __webpack_public_path__ + "img/bg-signin.7f7796d8.jpg";